import { useEffect } from 'react';
import { RouteName, TextKey } from '@mews-commander/enums';
import { LocalizedParagraph, LocalizedSmallParagraph } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { lt, useGainsightService } from '@mews/framework';
import { Button, Container, EmptyState } from '@optimus-web/core';
import { showRouteInModal } from '../../../modules/app/actions/common';
import { MatchAndMergeGainSightEvents } from './GainSightEvents';
import { MergeMode } from './types';

export const AccountMergeEmptyContent = ({ mergeMode }: { mergeMode: MergeMode }) => {
    const gainSightService = useGainsightService();
    const dispatch = useCommanderThunkDispatch();

    useEffect(() => {
        gainSightService.trackEvent(MatchAndMergeGainSightEvents.MatchAndMergeEmptyDisplayed, {});
    }, [gainSightService]);

    const navigateToDashboard = () => {
        gainSightService.trackEvent(MatchAndMergeGainSightEvents.MatchAndMergeClosed, {
            mergeMode,
        });
        dispatch(showRouteInModal(RouteName.DashboardIndex));
    };

    return (
        <Container align="center" padding="800">
            <EmptyState
                pictogram="tada"
                primaryText={<LocalizedParagraph textKey={TextKey.AccountMergeEmptyPagePrimaryLabel} />}
                secondaryText={<LocalizedSmallParagraph textKey={TextKey.AccountMergeEmptyPageSecondaryLabel} />}
                action={
                    <Button variant="primary" onClick={navigateToDashboard} type="submit">
                        {lt('AccountMergeEmptyPageReturnHomeButtonLabel')}
                    </Button>
                }
            />
        </Container>
    );
};
